import { render, staticRenderFns } from "./platformPage.vue?vue&type=template&id=277a5bd8"
import script from "./platformPage.vue?vue&type=script&lang=js"
export * from "./platformPage.vue?vue&type=script&lang=js"
import style0 from "./platformPage.vue?vue&type=style&index=0&id=277a5bd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports